import type { FC } from "react";
import { DashboardCardSlot } from "web_myplann/Dashboard/Components/DashboardCardSlot";
import { DashboardCardV2Content } from "web_myplann/Dashboard/Components/DashboardCardV2Content";
import { DashboardGoalsCardContent } from "web_myplann/Dashboard/Components/DashboardGoalsCardContent";
import type { AnimationDirection } from "web_myplann/Dashboard/Hooks/useDashboardAnimation";
import { useDashboardCardSlots } from "web_myplann/Dashboard/Hooks/useDashboardCardSlots";
import type { DashboardSlide } from "web_myplann/Dashboard/Types/DashboardSlide";
import { isGoalsSlide } from "web_myplann/Dashboard/Utils/isGoalsSlide";

type Props = {
	dashboard: DashboardSlide;
	direction: AnimationDirection;
	navigateToDashboardDetail?: () => void;
	onTooltipToggle?: (open: boolean) => void;
};

const SLOT_INDEXES = [0, 1] as const;

export const DashboardCardSlider: FC<Props> = ({
	dashboard,
	direction,
	navigateToDashboardDetail,
	onTooltipToggle,
}) => {
	const { slots, frontSlot, isEntering, getSlotTransform } =
		useDashboardCardSlots(dashboard, direction);

	return (
		<>
			{SLOT_INDEXES.map((slotIndex) => {
				const slot = slots[slotIndex];

				return (
					<DashboardCardSlot
						key={slotIndex}
						transform={getSlotTransform(slotIndex)}
						isAnimated={!isEntering}
						isFront={slotIndex === frontSlot}
					>
						{isGoalsSlide(slot) ? (
							<DashboardGoalsCardContent
								slide={slot}
								navigateToDashboardDetail={navigateToDashboardDetail}
							/>
						) : (
							<DashboardCardV2Content
								dashboardData={slot}
								navigateToDashboardDetail={navigateToDashboardDetail}
								onTooltipToggle={
									slotIndex === frontSlot ? onTooltipToggle : undefined
								}
							/>
						)}
					</DashboardCardSlot>
				);
			})}
		</>
	);
};
